import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const PatchSurveyStatus = async ({
    surveyId,
    action,
    note,
    highlightedQuestions
}: {
    surveyId: string;
    action: 'approve' | 'reject';
    note?: string;
    highlightedQuestions?: string[];
}): Promise<ISurveyFull | null> => {
    try {
        const response = await Requester<ISurveyFull>({
            path: `surveys/${surveyId}/review/${action}`,
            method: 'PATCH',
            payload: {
                note,
                surveyQuestions: action === 'reject' ? highlightedQuestions : undefined
            }
        });

        return '_id' in response ? response : null;
    } catch (e) {
        console.error('Patch survey status request failed');
        return Promise.reject(e);
    }
};
